<div *ngIf="osVersion">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>extension</mat-icon>
      {{
        osVersion.id ? "OS Version - " + osVersion.name : "Create new OS Version"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ osVersion.id ? "save" : "add" }}</mat-icon>
        {{ osVersion.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="osVersion.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">OS Version Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="osVersion.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="osVersion.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <input
                [(ngModel)]="osVersion.description"
                maxlength="50"
                id="description"
                name="description"
              />
              <!-- <textarea
                [(ngModel)]="osVersion.description"
                maxlength="50"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea> -->
            </td>
          </tr>
          <tr>
            <th [ngClass]="osVersion.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
                
              ></micro-valid-label>
            </th>
            <td>
              <input
                type="checkbox"
                [checked]="osVersion.active === 'Y'"
                (change)="onCheckboxChange($event)"
                id="active"
                name="active"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="osFamilyName"
                [model]="osFamilyName"
                label="OS"
              ></micro-valid-label>
            </th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbOsFamily"
                [(id)]="osVersion.osFamilyId"
                [defaultOption]="selectedOsFamily"
                placeholder="OS family"
                routerBase="os"
                (objectChange)="onOsFamilyChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
